var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shoplazza-page" },
    [
      _c("page-background"),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c("top-nav", {
            attrs: {
              "store-name": _vm.storeName,
              "platform-label": _vm.platformLabel,
            },
          }),
          _c("div", { staticClass: "page-body" }, [
            _c(
              "div",
              { staticClass: "select-outer" },
              [
                _c("select-app-card", {
                  attrs: {
                    "merchant-id": _vm.merchantId,
                    apps: _vm.appList,
                    "selected-app": _vm.selectedApp,
                    loading: _vm.loading,
                    confirming: _vm.confirming,
                    regions: _vm.regions,
                    "platform-label": _vm.platformLabel,
                  },
                  on: { select: _vm.handleSelect, confirm: _vm.handleConfirm },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("credentials-modal", {
        attrs: {
          visible: _vm.showCredentialsModal,
          "app-name": _vm.authResult.app_name,
          "store-name": _vm.authResult.shop_name || _vm.storeName,
          "mer-no": _vm.authResult.mer_no,
          "sign-key": _vm.authResult.sign_key,
          "app-key": _vm.authResult.app_key,
          redirect: _vm.authResult.redirect,
          "already-bound": _vm.alreadyBound,
          platform: _vm.platform,
          "platform-label": _vm.platformLabel,
        },
        on: {
          close: function ($event) {
            _vm.showCredentialsModal = false
          },
          "open-settings": _vm.handleOpenSettings,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }